/** App-wide constants. */

// Maximum vials a single cryopreservation box holds.
// Used for capacity bars, remaining-space math, and low-space alerts.
export const BOX_CAPACITY = 100;
